import {
  BirthControlMethodBreakpointOption,
  BreakpointAction,
  ChoiceFunction,
  QuizDataInput,
} from '@naturalcycles/shared'
import { allQuizSections } from '@src/app/cnst/quiz/quiz.cnst.js'
import { QuizPage } from '@src/app/cnst/quiz/quiz-pages.cnst.js'
import { addPageToFlowAtEndOfSection, removePagesFromFlow } from '@src/app/util/quiz.util.js'
import { DefaultQuizSection } from '@src/typings/quiz.enum.js'

const hormonalTransformFunction: ChoiceFunction<QuizPage, QuizDataInput> = flow => {
  const updatedFlow = addPageToFlowAtEndOfSection(
    flow,
    DefaultQuizSection.goal,
    QuizPage.sideEffects,
  )

  updatedFlow[allQuizSections.cycle] = [QuizPage.hormonalBirthControlHowLongPrevent]
  return updatedFlow
}

const copperIUDTransformFunction: ChoiceFunction<QuizPage, QuizDataInput> = flow => {
  const updatedFlow = addPageToFlowAtEndOfSection(
    flow,
    DefaultQuizSection.goal,
    QuizPage.sideEffects,
  )

  updatedFlow[allQuizSections.cycle] = [
    QuizPage.cycleLength,
    QuizPage.periodRegularity,
    QuizPage.periodRegularityInfo,
    QuizPage.lastPeriodDate0,
    QuizPage.medicalConditionsPrevent,
  ]

  return updatedFlow
}

const nonHormonalTransformFunction: ChoiceFunction<QuizPage, QuizDataInput> = flow => {
  /**
   * When nonHormonal is selected, sideEffects and sideEffectsInfo page is skipped.
   * This removes those pages in case the user selected hormonal/copperUID earlier.
   */
  const updatedFlow = removePagesFromFlow(flow, DefaultQuizSection.goal, [
    QuizPage.sideEffects,
    QuizPage.sideEffectsInfo,
  ])
  updatedFlow[allQuizSections.cycle] = [
    QuizPage.cycleLength,
    QuizPage.periodRegularity,
    QuizPage.periodRegularityInfo,
    QuizPage.lastPeriodDate0,
    QuizPage.medicalConditionsPrevent,
  ]
  return updatedFlow
}

export const birthControlMethodOuraSyncABTest: BreakpointAction<
  BirthControlMethodBreakpointOption,
  QuizPage,
  QuizDataInput
> = {
  // Hormonal
  [BirthControlMethodBreakpointOption.pill]: hormonalTransformFunction,
  [BirthControlMethodBreakpointOption.shot]: hormonalTransformFunction,
  [BirthControlMethodBreakpointOption.implant]: hormonalTransformFunction,
  [BirthControlMethodBreakpointOption.hormonalIUD]: hormonalTransformFunction,
  [BirthControlMethodBreakpointOption.patch]: hormonalTransformFunction,
  [BirthControlMethodBreakpointOption.nuvaRing]: hormonalTransformFunction,

  // Copper IUD
  [BirthControlMethodBreakpointOption.copperIUD]: copperIUDTransformFunction,

  // Non-hormonal
  [BirthControlMethodBreakpointOption.condom]: nonHormonalTransformFunction,
  [BirthControlMethodBreakpointOption.pullOut]: nonHormonalTransformFunction,
  [BirthControlMethodBreakpointOption.other]: nonHormonalTransformFunction,
  [BirthControlMethodBreakpointOption.none]: nonHormonalTransformFunction,
}
